/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { getWindow } from '../functions';
export var useMediaQuery = function (queryString) {
    var _a = React.useState(), matches = _a[0], setMatches = _a[1];
    React.useLayoutEffect(function () {
        var _a, _b, _c;
        var mediaQueryList = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.matchMedia) === null || _b === void 0 ? void 0 : _b.call(_a, queryString);
        var handleChange = function (_a) {
            var matches = _a.matches;
            return setMatches(matches);
        };
        if (mediaQueryList != undefined) {
            setMatches(mediaQueryList.matches);
            try {
                mediaQueryList.addEventListener('change', handleChange);
            }
            catch (_d) {
                // Safari 13 fallback
                (_c = mediaQueryList.addListener) === null || _c === void 0 ? void 0 : _c.call(mediaQueryList, handleChange);
            }
        }
        return function () {
            var _a;
            try {
                mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.removeEventListener('change', handleChange);
            }
            catch (_b) {
                // Safari 13 fallback
                (_a = mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.removeListener) === null || _a === void 0 ? void 0 : _a.call(mediaQueryList, handleChange);
            }
        };
    }, [queryString]);
    return !!matches;
};
export default useMediaQuery;
